import { Box, Button, HStack, IconButton, Menu, Portal, Text, VStack } from '@chakra-ui/react'
import { FiChevronDown, FiInfo, FiMoreHorizontal, FiX } from 'react-icons/fi'
import type { ScriptLanguage } from '../../../lib/walkPrefs'

/** [Spec §4.4/§4.6] Slim door header: × back to the walk, address, who's here, Info, and (contact walk) ⋯. */
export function DoorHeader({ title, subtitle, onClose, onInfo, menu, language }: {
  title: string; subtitle: string; onClose: () => void; onInfo: () => void; menu: { label: string; onSelect: () => void }[]
  language?: { value: ScriptLanguage; onToggle: () => void }
}) {
  return (
    <HStack px={2} py={2} gap={1} borderBottomWidth="1px" borderColor="border" bg="surface">
      <IconButton aria-label="Back to walk" variant="ghost" minW="44px" minH="44px" onClick={onClose}><FiX /></IconButton>
      <VStack align="flex-start" gap={0} flex={1} minW={0}>
        <Text fontWeight="bold" lineClamp={1}>{title}</Text>
        <Text fontSize="sm" color="fg.muted" lineClamp={1}>{subtitle}</Text>
      </VStack>
      {language && (
        <Button variant="outline" borderColor="border" minW="44px" minH="44px" px={2}
          aria-label={language.value === 'en' ? 'Switch script to Spanish' : 'Switch script to English'} onClick={language.onToggle}>
          {language.value === 'en' ? 'ES' : 'EN'}
        </Button>
      )}
      <Button variant="ghost" minH="44px" onClick={onInfo}><FiInfo aria-hidden />Info<FiChevronDown aria-hidden /></Button>
      {menu.length > 0 && (
        <Menu.Root positioning={{ placement: 'bottom-end' }}>
          <Menu.Trigger asChild>
            <IconButton aria-label="More" variant="ghost" minW="44px" minH="44px"><FiMoreHorizontal /></IconButton>
          </Menu.Trigger>
          <Portal>
            <Menu.Positioner>
              <Menu.Content>
                {menu.map(m => <Menu.Item key={m.label} value={m.label} minH="44px" onSelect={m.onSelect}>{m.label}</Menu.Item>)}
              </Menu.Content>
            </Menu.Positioner>
          </Portal>
        </Menu.Root>
      )}
      <Box w={1} />
    </HStack>
  )
}
